<div *ngIf="transactions?.length > 0">
    <p class="mt-2 mb-1">
        Recent Transactions
    </p>
    <div *ngFor="let transaction of transactions">
        <a href="{{getBaseUrl(transaction.network)}}{{transaction.transactionHash}}" target="_blank" class="trxns">{{transaction.successMessage}}</a>
    </div>
</div>
